import asyncActionTypes from '../actions/types.js';

const initialState = {
  arrayOfCodes: [],
  fulfillMessageFetched: false,
  loadingRefundReason: false,
  quoteMessageFetched: false,
  specialButton: false,
  errorRefundReason: false,
};

const refundReason = (state = initialState, action = {}) => {
  switch (action.type) {
    case asyncActionTypes.RETRIEVE_REFUND_REASON.START:
      return {
        ...state,
        loadingRefundReason: true,
        arrayOfCodes: initialState.arrayOfCodes,
      };
    case asyncActionTypes.RETRIEVE_REFUND_REASON.SUCCESS:
      const subcodesArray = action?.payload?.map(item => {
        return {
          subcode: item?.subcode,
          description: item?.description,
          reason: item?.reason,
          specialButton: item?.specialButton === 'True',
          processing: item?.processing,
        };
      });

      return {
        ...state,
        loadingRefundReason: false,
        arrayOfCodes: subcodesArray,
        quoteMessageFetched: action.quoteOrFulfill === 'quote' ? true : state.quoteMessageFetched,
        fulfillMessageFetched: action.quoteOrFulfill === 'fulfill' ? true : state.fulfillMessageFetched,
      };
    case asyncActionTypes.RETRIEVE_REFUND_REASON.FAIL:
      return {
        ...state,
        loadingRefundReason: false,
        errorRefundReason: true,
      };
    default:
      return state;
  }
};

export default refundReason;